import { Component, ViewChild, Output, EventEmitter, Input, OnInit, OnChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'app-comune-building-autocomplete',
  templateUrl: './comune-building-autocomplete.component.html',
  styleUrls: ['./comune-building-autocomplete.component.scss'],
})
export class ComuneBuildingAutocompleteComponent implements OnChanges {
  @Input() comuniList: any;
  @Input() comuneLabel: string;
  @Output() comuneSelected = new EventEmitter<any>();

	comuneControl = new FormControl();
  comuniOptions: any;
  convertedComuniList: any;

  ngOnChanges(changes) {
    if (changes && changes.comuniList) {
      this._initAutoComplete();
    }
  }

  emitComune(e) {
	  this.comuneSelected.emit(e);
		this.comuneLabel = e[1]
  }

  private _filter = (value: string | any, list) => {
	const isEntireObject = value instanceof Object

	return list.filter((option: any) => {
		const optionParsed = option[1] ? option[1].toLowerCase() : ""
		const valueParsed = !isEntireObject && value ? value.toLowerCase() : value && value[1] ? value[1].toLowerCase() : ""
		return optionParsed.includes(valueParsed)
	})
}

  private _initAutoComplete() {
    if (this.comuniList) {
      this.convertedComuniList = Object.entries(this.comuniList)
      this.comuniOptions = this.comuneControl.valueChanges.pipe(
        startWith(''),
        map((value) => this._filter(value as string, this.convertedComuniList)),
      );
    }
  }

}
